module.exports = __webpack_public_path__ + "img/GAME_GATU.24b9fd16.png";